(function(){
  if (window.__avProductCardEditorial10) return;
  window.__avProductCardEditorial10 = true;

  function setButton(button, text, disabled){
    if (!button) return;
    var label = button.querySelector('[data-av-card-button-text]') || button;
    label.textContent = text;
    if (typeof disabled === 'boolean') button.disabled = disabled;
  }

  document.addEventListener('submit', function(event){
    var form = event.target.closest('.av-product-card__form--ajax');
    if (!form || !window.fetch) return;

    event.preventDefault();
    var button = form.querySelector('[data-av-card-submit]');
    var defaultText = button ? button.getAttribute('data-default-text') : 'Adicionar';
    setButton(button, 'Adicionando', true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
    .then(function(response){
      if (!response.ok) throw new Error('cart-add-failed');
      return response.json();
    })
    .then(function(){
      setButton(button, 'Adicionado', true);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('av:product-card-added', { detail: { form: form }}));
      setTimeout(function(){ setButton(button, defaultText, false); }, 1400);
    })
    .catch(function(){
      setButton(button, 'Ver produto', false);
      var article = form.closest('[data-av-product-card]');
      var link = article ? article.querySelector('.av-product-card__title a') : null;
      if (link) window.location.href = link.href;
    });
  });

  document.addEventListener('mouseenter', function(event){
    var thumb = event.target.closest('[data-av-card-thumb]');
    if (!thumb) return;
    var card = thumb.closest('[data-av-product-card]');
    if (!card) return;
    var image = card.querySelector('.av-product-card__image--primary');
    var src = thumb.getAttribute('data-image');
    if (image && src) {
      image.src = src;
      image.removeAttribute('srcset');
    }
  }, true);
})();
